export default "<div [class.vle-loader--noheartbeat]=\"isAnimationDisabled\" class=\"vle-loader\">\n  <ng-content></ng-content>\n</div>\n";